import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { Box, List, ListItem, ListItemText, TextField, Typography, Paper, Button } from '@mui/material';
import { formatDate } from '../utils';

const PeopleList = () => {
    const [people, setPeople] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        axios.get(`/api/people?search=${searchTerm}`)
            .then(response => setPeople(response.data))
            .catch(error => console.error('Error fetching people:', error));
    }, [searchTerm]);

    return (
        <Box sx={{ maxWidth: 600, mx: 'auto' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <Typography variant="h4" sx={{ fontWeight: 700, flexGrow: 1 }}>
                    Personas
                </Typography>
                <Button variant="contained" onClick={() => navigate('/people/new')}>
                    + Nueva persona
                </Button>
            </Box>
            <TextField
                placeholder="Buscar por nombre..."
                variant="outlined"
                fullWidth
                sx={{ mb: 2 }}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
                <List disablePadding>
                    {people.map((person, index) => (
                        <ListItem
                            key={person.id_person}
                            component={Link}
                            to={`/tree/${person.id_person}`}
                            divider={index < people.length - 1}
                            sx={{
                                textDecoration: 'none',
                                color: 'inherit',
                                borderRadius: index === 0 ? '10px 10px 0 0' : index === people.length - 1 ? '0 0 10px 10px' : 0,
                                '&:hover': { bgcolor: 'rgba(62,44,28,0.05)' },
                                transition: 'background-color 0.15s',
                            }}
                        >
                            <ListItemText
                                primary={`${person.firstname} ${person.lastname}`}
                                secondary={
                                    [formatDate(person.birthday), formatDate(person.decease)].filter(Boolean).join(' — ') || null
                                }
                                primaryTypographyProps={{ fontWeight: 500 }}
                                secondaryTypographyProps={{ fontSize: '0.8rem' }}
                            />
                        </ListItem>
                    ))}
                </List>
            </Paper>
        </Box>
    );
};

export default PeopleList;
